import { Button, Icon, Popup } from 'semantic-ui-react';

function RunCommand({ issue_key, spec_file }) {
	const handleCopy = async () => {
		const text = `npm run headless -- --spec ${spec_file} --url https://e2e.focus.support/${issue_key}`;

		navigator.clipboard.writeText(text);
	}

	return (
		<Popup
			trigger={<Button onClick={handleCopy}><Icon name="copy outline" /></Button>}
			content="Copy run command"
			basic
		/>
	)
}

export default RunCommand;
